import styled from '@emotion/styled';
import { grayScale } from 'app/colors';

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
`;

export const Card = styled.div<{ padding?: string }>`
  background-color: ${grayScale.white};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 50px;
  height: 100vh;
  overflow: auto;
  animation: fadeIn 1s ease-in-out;
  ${({ padding }) =>
    padding && `padding-right: ${padding}px; padding-left: ${padding}px;`}
`;

export const FormWrapper = styled.div<{ padding?: string }>`
  gap: 20px;
  width: 100vw;
  height: 50vh;
  min-width: 350px;
  min-height: 350px;
  ${({ padding }) =>
    padding && `padding-right: ${padding}px; padding-left: ${padding}px;`}
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const InputWrapper = styled.div<{ error?: boolean }>`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  gap: 5px;
  ${({ error }) => error && `margin-bottom: -2px;`}
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 36px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
`;

export const Fields = styled.div`
  display: flex;
  gap: 35px;
`;

export const SuccessMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: fadeIn 1s ease-in-out;
  text-align: center;
`;

export const VideoWrapper = styled.div`
  max-height: 400px;
  pointer-events: none;
`;

export const CTAWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;

export const Testimonial = styled.div`
  text-align: center;
  padding-top: 60px;
  width: 100%;

  & > div {
    width: 75%;
    margin: 0 auto;
  }
`;
